export class Environment {
  readonly production: boolean;
  readonly mockDomaine: string;
  readonly baseUrlSpa: string;
  readonly creditEndpoint: string;
  readonly creditFiservEndpoint: string;
  readonly bancaireEndpoint: string;
  readonly mock: boolean;
  readonly keyPosteCanada: string;
  readonly identifiantProjetPosteCanada: string;
  readonly spinnerTimeout: number;
}
